import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { mappingResultError, Result } from '@digibricks/core';
import { ASSIGNMENT_REPOSITORY } from '../../core';
import { ASSIGNMENT_API } from '../data-sources/apis';
import { AssignmentMapper } from './assignment.mapper';
export var AssignmentRepository = /*#__PURE__*/function () {
  function AssignmentRepository(assignmentApi, mapper) {
    _classCallCheck(this, AssignmentRepository);

    this.assignmentApi = assignmentApi;
    this.mapper = mapper;
  }

  _createClass(AssignmentRepository, [{
    key: "getManyForResponder",
    value: function () {
      var _getManyForResponder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(queryParams) {
        var _this = this;

        var responseOrError, assignmentDtos, results, resultCombine;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.assignmentApi.getAssignmentsForResponder(queryParams);

              case 2:
                responseOrError = _context.sent;

                if (!responseOrError.isFailure) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", mappingResultError(responseOrError));

              case 5:
                assignmentDtos = responseOrError.getValue();
                results = [];
                assignmentDtos.forEach(function (dto) {
                  results.push(_this.mapper.toDomain(dto));
                });
                resultCombine = Result.combineArray(results);

                if (!resultCombine.isFailure) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return", Result.fail(resultCombine.error));

              case 11:
                return _context.abrupt("return", Result.ok(resultCombine.getValue()));

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getManyForResponder(_x) {
        return _getManyForResponder.apply(this, arguments);
      }

      return getManyForResponder;
    }()
  }, {
    key: "getMany",
    value: function () {
      var _getMany = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(query) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.assignmentApi.getAssignments(query);

              case 2:
                responseOrError = _context2.sent;

                if (!responseOrError.isFailure) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", mappingResultError(responseOrError));

              case 5:
                return _context2.abrupt("return", responseOrError);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getMany(_x2) {
        return _getMany.apply(this, arguments);
      }

      return getMany;
    }()
  }, {
    key: "getById",
    value: function () {
      var _getById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id) {
        var responseDtoOrError, assignmentOrError;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.assignmentApi.getById(id);

              case 2:
                responseDtoOrError = _context3.sent;

                if (!responseDtoOrError.isFailure) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return", Result.fail(responseDtoOrError.error));

              case 5:
                assignmentOrError = this.mapper.toDomain(responseDtoOrError.getValue());

                if (!assignmentOrError.isFailure) {
                  _context3.next = 8;
                  break;
                }

                return _context3.abrupt("return", Result.fail(assignmentOrError.error));

              case 8:
                return _context3.abrupt("return", Result.ok(assignmentOrError.getValue()));

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getById(_x3) {
        return _getById.apply(this, arguments);
      }

      return getById;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(useCaseInput) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.assignmentApi.update(useCaseInput);

              case 2:
                responseOrError = _context4.sent;

                if (!responseOrError.isFailure) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return", Result.fail(responseOrError.error));

              case 5:
                return _context4.abrupt("return", Result.ok());

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function update(_x4) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.assignmentApi["delete"](id);

              case 2:
                responseOrError = _context5.sent;

                if (!responseOrError.isFailure) {
                  _context5.next = 5;
                  break;
                }

                return _context5.abrupt("return", mappingResultError(responseOrError));

              case 5:
                return _context5.abrupt("return", Result.ok());

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _delete(_x5) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }() // Attendee

  }, {
    key: "createAttendee",
    value: function () {
      var _createAttendee = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(input) {
        var responseOrError, response;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.assignmentApi.createAttendee(input);

              case 2:
                responseOrError = _context6.sent;

                if (!responseOrError.isFailure) {
                  _context6.next = 5;
                  break;
                }

                return _context6.abrupt("return", mappingResultError(responseOrError));

              case 5:
                response = responseOrError.getValue();
                return _context6.abrupt("return", Result.ok(response));

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function createAttendee(_x6) {
        return _createAttendee.apply(this, arguments);
      }

      return createAttendee;
    }()
  }, {
    key: "getAttendees",
    value: function () {
      var _getAttendees = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(useCaseInput) {
        var responseOrError, responses;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.assignmentApi.getAttendees(useCaseInput);

              case 2:
                responseOrError = _context7.sent;

                if (!responseOrError.isFailure) {
                  _context7.next = 5;
                  break;
                }

                return _context7.abrupt("return", mappingResultError(responseOrError));

              case 5:
                responses = responseOrError.getValue();
                return _context7.abrupt("return", Result.ok(responses));

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getAttendees(_x7) {
        return _getAttendees.apply(this, arguments);
      }

      return getAttendees;
    }()
  }, {
    key: "getAttendeeById",
    value: function () {
      var _getAttendeeById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(useCaseInput) {
        var responseOrError, response;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.assignmentApi.getAttendeeById(useCaseInput);

              case 2:
                responseOrError = _context8.sent;

                if (!responseOrError.isFailure) {
                  _context8.next = 5;
                  break;
                }

                return _context8.abrupt("return", mappingResultError(responseOrError));

              case 5:
                response = responseOrError.getValue();
                return _context8.abrupt("return", Result.ok(response));

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getAttendeeById(_x8) {
        return _getAttendeeById.apply(this, arguments);
      }

      return getAttendeeById;
    }()
  }, {
    key: "verifyPassword",
    value: function () {
      var _verifyPassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(input) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.assignmentApi.verifyPassword(input);

              case 2:
                responseOrError = _context9.sent;

                if (!responseOrError.isFailure) {
                  _context9.next = 5;
                  break;
                }

                return _context9.abrupt("return", mappingResultError(responseOrError));

              case 5:
                return _context9.abrupt("return", Result.ok());

              case 6:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function verifyPassword(_x9) {
        return _verifyPassword.apply(this, arguments);
      }

      return verifyPassword;
    }()
  }]);

  return AssignmentRepository;
}();
export var assignmentRepositoryProvider = {
  provide: ASSIGNMENT_REPOSITORY,
  useFactory: function useFactory(assignmentApi, mapper) {
    return new AssignmentRepository(assignmentApi, mapper);
  },
  inject: [ASSIGNMENT_API, AssignmentMapper]
};